import _tmpl from "./gtmNoScript.html";
import { LightningElement, registerComponent as _registerComponent } from 'lwc';
class GtmNoScript extends LightningElement {
  /*LWC compiler v7.1.3*/
}
const __lwc_component_class_internal = _registerComponent(GtmNoScript, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;